/****************************************************
 * Module Name:  memoProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class MemoProxy {
  static GetAllMemoAtALocation = (locationId, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/memo/${locationId}/detail`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllMemoAtALocationByMemoId = (
    locationId,
    memoId,
    status,
    callback
  ) => {
    restAPICall(
      Constants.MANAGER_URL + `/memo/${locationId}/${memoId}/${status}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllMemoAtALocationByMemoIdAndMemoStatus = (
    locationId,
    memoId,
    status,
    callback
  ) => {
    restAPICall(
      Constants.MANAGER_URL + `/memo/${locationId}/${memoId}/${status}/detail`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };


  static GetAllMemoAtALocationByUserId = (
    locationId,
    loggedInUserId,
    userIds,
    status,
    callback
  ) => {
    restAPICall(
      Constants.MANAGER_URL + `/memo/${locationId}/${loggedInUserId}/${userIds}/${status}/detail`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetMemosForUserByPermissionAndLocation = (
    locationId,
    usertype,
    userId,
    status,
    selectedCustomers,
    callback
  ) => {
    restAPICall(
      Constants.MANAGER_URL + `/memo/${locationId}/${usertype}/${userId}/${status}/detail`,
      "post",
      Constants.userToken,
      undefined,
      selectedCustomers,
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static SendMemo = (locationId, memoId, data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/memo/${locationId}/${memoId}`,
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static SendMultipleMemo = (locationId, data, cleartag, callback) => {
    let params = {
      cleartag: cleartag
    }
    restAPICall(
      Constants.MANAGER_URL + `/memo/${locationId}/multiple`,
      "put",
      Constants.userToken,
      params,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static FindMemoByTags = (locationId, data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/memo/${locationId}/findtag`,
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static FindMemoByUserId = (id, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/memo/user/${id}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static SellStonesByMemo = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/sell/memo`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CreateProformaByMemo = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/sell/memo/performa`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static getMemoPDF = (locationId, memoId, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/memo/${locationId}/${memoId}/pdf`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static getNoOfMemoRequestByStoneId = (stoneid, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/memo/requested/${stoneid}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static getNoOfMemoOutByStoneId = (stoneid, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/memo/out/${stoneid}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetMemoOutStones = (
    locationId,
    loggedInUserId,
    userId,
    status,
    selectedCustomers,
    callback
  ) => {
    restAPICall(
      Constants.MANAGER_URL + `/memo/out/${locationId}/${loggedInUserId}/${userId}/${status}/detail`,
      "post",
      Constants.userToken,
      undefined,
      selectedCustomers,
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetIssuedStones = (
    locationId,
    customerid,
    callback
  ) => {
    restAPICall(
      Constants.MANAGER_URL + `/memo/issued/${locationId}/${customerid}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetCustomersCreatedMemo = (locationid, userid, usertype, statusList, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/memo/customers/${locationid}/${userid}/${usertype}`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(statusList),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CloseMemo = (memoid, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/memo/close/${memoid}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static convertMemoType = (stoneids, daymemo, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/memo/convert/${daymemo}`,
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(stoneids),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

}


